import { useEffect, useRef } from 'react'
import { accountLookup, useAppDispatch, useHandoffAuthSessionMutation, useLogLoginAttemptEvent } from '../../state'
import { useContinueAfterSignIn } from './useContinueAfterSignIn'

export const useSignInWithHandoff = (): ((sessionRef: string) => Promise<boolean>) => {
  const dispatch = useAppDispatch()
  const [handoffAuthSession] = useHandoffAuthSessionMutation()
  const continueAfterSignIn = useContinueAfterSignIn()
  const latestContinueAfterSignIn = useRef(continueAfterSignIn)
  const logLoginAttemptEvent = useLogLoginAttemptEvent({ is2fa: false })

  useEffect(() => {
    latestContinueAfterSignIn.current = continueAfterSignIn
  }, [continueAfterSignIn])

  return async (sessionRef) => {
    try {
      await handoffAuthSession({ sessionRef }).unwrap()
    } catch {
      logLoginAttemptEvent('Email Code', false)
      return false
    }
    logLoginAttemptEvent('Email Code', true)
    try {
      const account = await dispatch(accountLookup()).unwrap()
      await latestContinueAfterSignIn.current(account)
      return true
    } catch {
      return false
    }
  }
}
